"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _cards = require("../../styles/cards");

var _spacers = require("../../styles/spacers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // import { Rating } from "../.."
// const ProductRating = props => {
//   return (
//     <RatingContainer>
//       <Rating rating={props.rating} maxRating={5} />
//       <VerticalSpacer width={"5px"} />
//       <RatingValue>{props.rating || 0}</RatingValue>
//       {/* {(props.count && props.count > 0) && <RatingCount>{props.count}</RatingCount>} */}
//     </RatingContainer>
//   )
// }


var NotificationCard = function NotificationCard(props) {
  return /*#__PURE__*/_react["default"].createElement(_cards.NotifCardContainer, null, /*#__PURE__*/_react["default"].createElement(_cards.NotifImage, {
    src: props.cardImgSrc
  }), /*#__PURE__*/_react["default"].createElement(_spacers.VerticalSpacer, {
    width: "1rem"
  }), /*#__PURE__*/_react["default"].createElement(_cards.NotifDetails, null, /*#__PURE__*/_react["default"].createElement("div", null, props.brandName && /*#__PURE__*/_react["default"].createElement(_cards.BrandLabel, null, props.brandName), /*#__PURE__*/_react["default"].createElement(_cards.ProductName, null, props.productName), /*#__PURE__*/_react["default"].createElement(_cards.ProductInfo, null, props.size && /*#__PURE__*/_react["default"].createElement("div", null, "Size: ", props.size), props.size && /*#__PURE__*/_react["default"].createElement(_spacers.VerticalSpacer, {
    width: "1rem"
  }), props.color && /*#__PURE__*/_react["default"].createElement("div", null, "Color: ", props.color)), /*#__PURE__*/_react["default"].createElement(_cards.ProductInfo, null, /*#__PURE__*/_react["default"].createElement("div", null, "Quantity: ", props.quantity))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cards.PriceFormatter, {
    price: props.currentPrice
  }))));
};

var _default = NotificationCard;
exports["default"] = _default;
module.exports = exports["default"];